// The order of the search cards once their live prices have landed (Praveen, 6 Oct 2026: "Low to
// High" was not low to high).
//
// A page of cards is sorted when it loads (store/redux/Property/actions.js
// enhanceAndSortListings), on the price each card starts with: the base rate for the nights. A
// moment later the live quotes replace those prices (PATCH_LIVE_SEARCH_PRICES) and nothing
// sorted the page again, so a New Year week read 6,013 / 3,724 / 2,267 under "Low to High".
//
// For a price sort this puts the page in the order of the prices now shown. The rules of the
// first sort still hold: on-request villas last, villas matching more of the picked filters
// first. Any other sort, and a page with nothing to compare, comes back untouched.

const PRICE_SORT_FIELD = "data.prices.basePrice";

const shown = (property) => {
  const v = Number(property?.calculatedPrice?.totalAmount);
  return Number.isFinite(v) ? v : 0;
};
const onRequest = (property) => (property?.listing?.tags?.includes("onDemand") ? 1 : 0);
const matched = (property) => property?.listing?._tagMatch?.count || 0;

/**
 * @param {Array}  listings  the page's cards ({ listing, calculatedPrice, ... })
 * @param {string} sortBy    the sort in force, "field:1" or "field:-1"
 * @returns {Array} the same array when there is nothing to do, else a sorted copy
 */
export function orderByShownPrice(listings, sortBy) {
  if (!Array.isArray(listings) || listings.length < 2) return listings;
  const [field, dir] = String(sortBy || "").split(":");
  if (field !== PRICE_SORT_FIELD) return listings;
  const direction = parseInt(dir, 10) === -1 ? -1 : 1;
  // Array.prototype.sort is stable: cards that compare equal keep the order they came in.
  return [...listings].sort((a, b) => {
    const ra = onRequest(a), rb = onRequest(b);
    if (ra !== rb) return ra - rb;
    if (ra === 1) return 0; // on-request villas show no price to order by
    const ma = matched(a), mb = matched(b);
    if (ma !== mb) return mb - ma;
    return direction * (shown(a) - shown(b));
  });
}
